import { instance } from 'store/utils';
import { types } from './types';
import { downloadFile, downloadRequestHeaders } from 'store/forms/utils';
import { message } from 'antd';

export const react_path = process.env.REACT_APP_PROCESS_APP

export const getFormData = taskId => dispatch => {
    dispatch({ type: types.GET_FORM_DATA_APP.START });
    instance
      .get(`/app/rest/task-forms/${taskId}/with-vars`)
      .then(response => {
        dispatch({ type: types.GET_FORM_DATA_APP.SUCCESS, payload: response.data });
      })
      .catch(error => {
        console.log(error, 'error');
        dispatch({ type: types.GET_FORM_DATA_APP.ERROR });
      });
  };

  export const fetchProcessSAYT = searchKey => dispatch => {
    dispatch({ type: types.FETCH_PROCESS_SAYT.START });
    instance
    .get(`/app/rest/findSAYT?searchKey=` + searchKey)
      .then(response => {
        dispatch({ type: types.FETCH_PROCESS_SAYT.SUCCESS, payload: response.data });
      })
      .catch(error => {
        console.log(error, 'error');
        dispatch({ type: types.FETCH_PROCESS_SAYT.ERROR });
      });
  };

  export const getActions = procInstId => dispatch => {
    dispatch({ type: types.GET_ACTIONS.START });
    
    return instance
        .get(`/app/rest/${procInstId}/actions`)
        .then(response => {
            dispatch({ type: types.GET_ACTIONS.SUCCESS, payload: response.data });
            return response.data; 
        })
        .catch(error => {
            console.log(error, 'error');
            dispatch({ type: types.GET_ACTIONS.ERROR });
            throw error; 
        });
};
  
  export const getTaskData = taskId => dispatch => {
    dispatch({ type: types.GET_TASK_DATA.START });
    instance
      .get(`/app/rest/tasks/${taskId}`)
      .then(response => {
        dispatch({ type: types.GET_TASK_DATA.SUCCESS, payload: response.data });
      })
      .catch(error => {
        console.log(error, 'error');
        dispatch({ type: types.GET_TASK_DATA.ERROR });
      });
  };
  
  export const fetchProcInstancesDetailed = data => dispatch => {
    dispatch({ type: types.GET_PROCESS_INSTANCES_APP.START });
    instance
      .post(`/app/rest/process-instances-apptrack`, data)
      .then(response => {
        const res = response.data.data
        const results = Object.keys(res).map(key => ({
          id: key,
          ...res[key]
        }))
        dispatch({
          type: types.GET_PROCESS_INSTANCES_APP.SUCCESS,
          payload: {
            variables: results
          },
        });
        // if(!params.isViewMode){
        // dispatch(getFormData(params.taskId));
        // }
      })
      .catch(error => {
        console.log(error, 'error');
        dispatch({ type: types.GET_PROCESS_INSTANCES_APP.ERROR });
      });
  };

  export const fetchProcInstancesDetailedPaginated = (detailedPayload, page, pageSize) => dispatch => {
    let payload={
      parameterList: detailedPayload?.parameterList ?? [],
      page,
      pageSize
    }
    dispatch({ type: types.GET_PROCESS_INSTANCES_APP.START });
    instance
    .post(`/app/rest/process-instances-apptrack-paginated`, payload)
      .then(response => {
        const res = response.data.data;
        const resultSize = response?.data?.size;
        // const results = Object.keys(res).map(key => ({
        //   id: key,
        //   ...res[key]
        // }))
        const results = Object.entries(res).map(([key, value]) => ({
          id: key,
          ...value
        }));

        results.sort((a, b) => Number(a.businessKey) - Number(b.businessKey));

        dispatch({
          type: types.GET_PROCESS_INSTANCES_APP.SUCCESS,
          payload: {
            variables: results,
            resultSize: resultSize
          },
        });
      })
      .catch(error => {
        console.log(error, 'error');
        dispatch({ type: types.GET_PROCESS_INSTANCES_APP.ERROR });
      });
  };

export const fetchProcInstancesSupplierPaginated = (detailedPayload, page, pageSize) => dispatch => {
  let payload = {
    parameterList: detailedPayload?.parameterList ?? [],
    page,
    pageSize
  };

  dispatch({ type: types.GET_VOUCHERS_SUPPLIER.START });

  instance
    .post(`/supplier/voucher/search`, payload)
    .then(response => {
      const res = response.data.data;
      const resultSize = response?.data?.size;

      const results = Object.entries(res).map(([key, value]) => ({
        id: key,
        ...value
      }));

      results.sort((a, b) => Number(a.businessKey) - Number(b.businessKey));

      dispatch({
        type: types.GET_VOUCHERS_SUPPLIER.SUCCESS,
        payload: {
          variables: results,
          resultSize
        }
      });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_VOUCHERS_SUPPLIER.ERROR });
    });
};

export const fetchProcInstancesVoucherViewerPaginated =
  (detailedPayload, page, pageSize, vatId = null, voucherNumber = null) => dispatch => {

    const payload = {
      parameterList: detailedPayload?.parameterList ?? [],
      page,
      pageSize,
      vatId,
      voucherNumber,
    };

    dispatch({ type: types.GET_VOUCHERS_SUPPLIER.START });

    return instance
      .post(`/voucher-viewer/voucher/search`, payload)
      .then(response => {
        const res = response.data.data;
        const resultSize = response?.data?.size;

        const results = Object.entries(res).map(([key, value]) => ({
          id: key,
          ...value
        }));

        results.sort((a, b) => Number(a.businessKey) - Number(b.businessKey));

        dispatch({
          type: types.GET_VOUCHERS_SUPPLIER.SUCCESS,
          payload: { variables: results, resultSize }
        });

        return response.data;
      })
      .catch(error => {
        console.log(error, 'error');
        dispatch({ type: types.GET_VOUCHERS_SUPPLIER.ERROR });
        throw error;
      });
  };



export const fetchProcInstancesVoucherAuditorPaginated = (detailedPayload, page, pageSize) => dispatch => {
  let payload={
    parameterList: detailedPayload?.parameterList ?? [],
    page,
    pageSize
  }
  dispatch({ type: types.GET_VOUCHERS_VOUCHER_AUDITOR.START });
  instance
  .post(`/auditor/voucher/search`, payload)
    .then(response => {
      const res = response.data.data;
      const resultSize = response?.data?.size;
      // const results = Object.keys(res).map(key => ({
      //   id: key,
      //   ...res[key]
      // }))
      const results = Object.entries(res).map(([key, value]) => ({
        id: key,
        ...value
      }));

      results.sort((a, b) => Number(a.businessKey) - Number(b.businessKey));

      dispatch({
        type: types.GET_VOUCHERS_VOUCHER_AUDITOR.SUCCESS,
        payload: {
          variables: results,
          resultSize: resultSize
        },
      });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_VOUCHERS_VOUCHER_AUDITOR.ERROR });
    });
};
export const getActionsVoucher = (voucher, groups = []) => dispatch => {
  dispatch({ type: types.GET_VOUCHER_ACTIONS.START });

  const groupNames = (groups || [])
    .map(g => g?.name || g?.id)
    .filter(Boolean);

  const isVoucherViewer = groupNames.includes("VoucherViewerGroup");

  const request = isVoucherViewer
    ? instance.get(`/voucher-viewer/voucher/actions/${voucher}`)
    : instance.get(`/supplier/actions/${voucher}`);

  return request
    .then(response => {
      dispatch({ type: types.GET_VOUCHER_ACTIONS.SUCCESS, payload: response.data });
      return response.data;
    })
    .catch(error => {
      console.log(error, "error");
      dispatch({ type: types.GET_VOUCHER_ACTIONS.ERROR });
      throw error;
    });
};


  export const fetchVoucherStatuses  = () => dispatch => {
    dispatch({ type: types.GET_VOUCHER_STATUS.START });
    
    return instance
        .get(`/supplier/voucher/statuses`)
        .then(response => {
            dispatch({ type: types.GET_VOUCHER_STATUS.SUCCESS, payload: response.data });
            return response.data; 
        })
        .catch(error => {
            console.log(error, 'error');
            dispatch({ type: types.GET_VOUCHER_STATUS.ERROR });
            throw error; 
        });
};
export const fetchVoucherStatusesVoucherViewer = () => dispatch => {
  dispatch({ type: types.GET_VOUCHER_STATUS.START });

  return instance
    .get(`/voucher-viewer/voucher/statuses`)
    .then(response => {
      dispatch({ type: types.GET_VOUCHER_STATUS.SUCCESS, payload: response.data });
      return response.data;
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_VOUCHER_STATUS.ERROR });
      throw error;
    });
};


export const fetchVoucherByNuber = (afmField, voucherNumber) => dispatch => {
  dispatch({ type: types.GET_VOUCHER_BY_NUMBER.START });

  return instance
    .get(`/supplier/voucher/search?voucherNumber=${voucherNumber}&vatId=${afmField}`)
    .then(response => {
      dispatch({ type: types.GET_VOUCHER_BY_NUMBER.SUCCESS, payload: response.data });
      return response.data;
    })
    .catch(error => {
      console.log('error in check', error.response.data.responseDescription);
      dispatch({
        type: types.GET_VOUCHER_BY_NUMBER.ERROR,
        payload: error.response.data.responseDescription
      });
      throw error;
    });
};

// export const fetchVoucherByNuberVoucherViewer = (afmField, voucherNumber) => dispatch => {
//   dispatch({ type: types.GET_VOUCHERS_SUPPLIER.START });

//   return instance
//     .get(`/voucher-viewer/voucher/search`, {
//       params: {
//         vatId: afmField,
//         voucherNumber
//       }
//     })
//     .then(response => {

//       const res = response?.data?.data ?? [];
//       const resultSize = response?.data?.size ?? (Array.isArray(res) ? res.length : Object.keys(res).length);

//       const results = Array.isArray(res)
//         ? res.map((item, idx) => ({
//             id: item?.id ?? item?.businessKey ?? String(idx),
//             ...item
//           }))
//         : Object.entries(res).map(([key, value]) => ({
//             id: key,
//             ...value
//           }));

//       results.sort((a, b) => Number(a.businessKey) - Number(b.businessKey));

//       dispatch({
//         type: types.GET_VOUCHERS_SUPPLIER.SUCCESS,
//         payload: { variables: results, resultSize }
//       });

//       return response.data;
//     })
//     .catch(error => {
//       const msg =
//         error?.response?.data?.responseDescription ??
//         'Request failed';

//       dispatch({ type: types.GET_VOUCHERS_SUPPLIER.ERROR, payload: msg });
//       throw error;
//     });
// };



export const setVoucherErrorDescription  = () => dispatch => {
  dispatch({ type: types.GET_VOUCHER_BY_NUMBER.ERROR, payload: ""});
}

export const fetchSupplierVoucher = voucher => dispatch => {

  dispatch({ type: types.GET_PROCESS_INSTANCES_APP.START });
  instance
  .post(`/supplier/voucher_by_number/${voucher}`)
    .then(response => {
      const res = response.data.data;
      const resultSize = response?.data?.size;
      // const results = Object.keys(res).map(key => ({
      //   id: key,
      //   ...res[key]
      // }))
      const results = Object.entries(res).map(([key, value]) => ({
        id: key,
        ...value
      }));

      results.sort((a, b) => Number(a.businessKey) - Number(b.businessKey));

      dispatch({
        type: types.GET_PROCESS_INSTANCES_APP.SUCCESS,
        payload: {
          variables: results,
          resultSize: resultSize
        },
      });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_PROCESS_INSTANCES_APP.ERROR });
    });
};

export const fetchVoucherVoucherAuditorWithParams  = (afmField, voucherNumber, applicationNumber) => dispatch => {
    dispatch({ type: types.GET_VOUCHER_VOUCHER_AUDITOR_WITH_PARAMS.START });
    const payload = {
      'voucherNumber': voucherNumber,
      'vatId': afmField,
      'applicationNumber': applicationNumber,
    }
    return instance
        .post(`/auditor/voucher/search`, payload)
        .then(response => {
          const res = response.data.data;
          const resultSize = response?.data?.size;
          // const results = Object.keys(res).map(key => ({
          //   id: key,
          //   ...res[key]
          // }))
          const results = Object.entries(res).map(([key, value]) => ({
            id: key,
            ...value
          }));

          results.sort((a, b) => Number(a.businessKey) - Number(b.businessKey));

            dispatch({ type: types.GET_VOUCHER_VOUCHER_AUDITOR_WITH_PARAMS.SUCCESS,  
              payload: {
              variables: results,
              resultSize: resultSize
              }, 
            });
            // return response.data; 
        })
        .catch(error => {
            console.log('error in check',error.response.data.responseDescription);
            dispatch({ type: types.GET_VOUCHER_VOUCHER_AUDITOR_WITH_PARAMS.ERROR, payload: error.response.data.responseDescription });
            throw error; 
        });
};

  export const clearApptrack = () => dispatch => {
    dispatch({ type: types.CLEAR_APPTRACK.SUCCESS });
  };

  export const clearSayt = () => dispatch => {
    dispatch({ type: types.CLEAR_SAYT });
  };

  export const navigateToView = (navigate, processInstanceId) => {
    navigate(`/apptrack/${processInstanceId}`);
  };

  export const cancelProcessInstance = (procInstId) => dispatch => {
    dispatch({ type: types.CANCEL_PROCESS.START });
    instance.get(`/app/rest/cancel-process-instance/${procInstId}`)
        .then(response => {
            dispatch({ type: types.CANCEL_PROCESS.SUCCESS, payload: response.data });
            window.location.reload();
        })
        .catch(error => {
            dispatch({ type: types.CANCEL_PROCESS.ERROR, error });
        });
};

export const cancelProcessInstanceExtended = (procInstId, isEquipment) => dispatch => {
  dispatch({ type: types.CANCEL_PROCESS_EXTENDED.START });
  instance.put(`app/rest/voucher/${procInstId}/cancel?isEquipment=${isEquipment}`)
      .then(response => {
          dispatch({ type: types.CANCEL_PROCESS_EXTENDED.SUCCESS, payload: response.data });
          window.location.reload();
      })
      .catch(error => {
          dispatch({ type: types.CANCEL_PROCESS_EXTENDED.ERROR, error });
      });
};

export const cancelAcceptedProcessInstance = (procInstId, onlyVoucher) => dispatch => {
  dispatch({ type: types.CANCEL_ACCEPTED_PROCESS_INSTANCE.START });
  instance.post(`app/rest/cancel-accepted-process-instance/${procInstId}?onlyVoucher=${onlyVoucher}`)
      .then(response => {
          dispatch({ type: types.CANCEL_ACCEPTED_PROCESS_INSTANCE.SUCCESS, payload: response.data });
          window.location.reload();
      })
      .catch(error => {
          dispatch({ type: types.CANCEL_ACCEPTED_PROCESS_INSTANCE.ERROR, error });
      });
};

export const releaseApplication = (voucherNumber) => dispatch => {
  dispatch({ type: types.RELEASE_APPLICATION.START });
  instance
      .post(`/app/rest/release-application`,
        {
          "voucherNumber": voucherNumber
        })
      .then(response => {
          dispatch({ type: types.RELEASE_APPLICATION.SUCCESS, payload: response.data });
          window.location.reload();
      })
      .catch(error => {
          console.log('error: ', error)
          dispatch({ type: types.RELEASE_APPLICATION.ERROR, payload: error?.response?.data });
      });
};

export const setReleaseApplicationErrorDescription  = () => dispatch => {
  dispatch({ type: types.RELEASE_APPLICATION.ERROR, payload: ""});
}

  export const unassignProcessInstanceExtended = (id) => dispatch => {
    dispatch({ type: types.UNASSIGN_PROCESS_EXTENDED.START });
    instance
    .delete('/app/rest/assign',
      { params: { processInstanceId: id },
    })
      .then(response => {
        dispatch({ type: types.UNASSIGN_PROCESS_EXTENDED.SUCCESS, payload: response.data });
        window.location.reload();
      })
      .catch(error => {
        console.log(error, 'error');
        dispatch({ type: types.UNASSIGN_PROCESS_EXTENDED.ERROR });
      });
  }

  export const getDetails = (processInstanceId) => {
    return  instance
    .get(`/app/rest/process-instance-apptrack-detailed/${processInstanceId}`)
      .then((response) => {
        return response.data.variablesIndexed;
      });
  }
  
  export const returnToEvaluation = (processInstanceId) =>{
    return instance.post(`/app/rest/return`, null, { params: { procInstId: processInstanceId } } )};

  export const getApptrackDetails = (processInstanceId) => dispatch => {
    dispatch({ type: types.GET_APPTRACK_DETAILS.START });

    instance
      .get(`/app/rest/process-instance-apptrack-detailed/${processInstanceId}`)
      .then((response) => {
        // console.log("RESPONSE",response.data);
        dispatch({
          type: types.GET_APPTRACK_DETAILS.SUCCESS,
          payload: {
            activeTaskId: response.data.activeTaskId,
            activeTaskName: response.data.activeTaskName,
            businessKey: response.data.businessKey,
            localTaskVariables: response.data.localTaskVariables,
            variablesIndexed: response.data.variablesIndexed,
            contentItems: response.data.contentItems,
            comments: response.data.comments,
          },
        });
      })
      .catch(error => {
        dispatch({ type: types.GET_APPTRACK_DETAILS.ERROR });

        console.log(error, 'error');
      });
  }

  export const getOffersHistory = () => dispatch => {
    dispatch({ type: types.GET_OFFERS_HISTORY.START });

    instance
      .get(`/app/rest/offers/uploads`)
      .then(response => {
        // console.log(response.data);
        dispatch({
          type: types.GET_OFFERS_HISTORY.SUCCESS,
          payload: response.data,
        });
      })
      .catch(error => {
        dispatch({ type: types.GET_OFFERS_HISTORY.ERROR });

        console.log(error, 'error');
      });
  };

  export const uploadOffers = ({file, callback}) => dispatch => {
    dispatch({ type: types.UPLOAD_OFFERS.START });

    instance
      .post(`/app/rest/offers/upload`, file)
      .then(response => {
        // console.log(response.data);
        dispatch({
          type: types.UPLOAD_OFFERS.SUCCESS
        });
        callback(true);
      })
      .catch(error => {
        dispatch({ type: types.UPLOAD_OFFERS.ERROR });
        callback(false);
        console.log(error, 'error');
      });
  };

  export const downloadUploadedFilev2 = (fileInfo) => dispatch => {
    message.loading("Αναμονή λήψης αρχείου");
    dispatch({ type: types.DOWNLOAD_UPLOADED_FILE.START });
    instance
      .get(`/app/rest/downloadFile?fileId=${fileInfo?.id}`, { responseType: "blob" })
      .then(response => {
        //create hidden anchor and click behind the scenes to trigger download
        const link = document.createElement("a");
        link.href = URL.createObjectURL(response.data);
        link.download = fileInfo?.filename;
        link.click();
        dispatch({
          type: types.DOWNLOAD_UPLOADED_FILE.SUCCESS,
        });
      })
      .catch(error => {
        console.log(error, 'error');
        dispatch({ type: types.DOWNLOAD_UPLOADED_FILE.ERROR });
        // message.error("Σφάλμα κατά τη λήψη του αρχείου");
      });
  };

  export const getActiveOffers = (infrprov = '') => dispatch => {
    dispatch({ type: types.GET_ACTIVE_OFFERS.START });

    instance
      .get(`/app/rest/offers/getAll${infrprov ? `/${infrprov}` : ''}`)
      .then(response => {
        // console.log(response.data);
        dispatch({
          type: types.GET_ACTIVE_OFFERS.SUCCESS,
          payload: response.data,
        });
      })
      .catch(error => {
        dispatch({ type: types.GET_ACTIVE_OFFERS.ERROR });

        console.log(error, 'error');
      });
  }

  export const clearActiveOffers = () => dispatch => {
    dispatch({type: types.CLEAR_ACTIVE_OFFERS.SUCCESS, payload: {}})
  }

  export const openUploadOffersModal = (open) => dispatch => {
    dispatch({type: types.OPEN_UPLOAD_OFFERS_MODAL.SUCCESS, payload: open})
  }
  export const openUploadProviderModal = (open) => dispatch => {
    dispatch({type: types.OPEN_UPLOAD_PROVIDER_MODAL.SUCCESS, payload: open})
  }
  export const setSelectedOffersFileFlag = (selected) => dispatch => {
    dispatch({type: types.SET_SELECTED_OFFERS_FILE.SUCCESS, payload: selected})
  }
  export const setSelectedProviderFileFlag = (selected) => dispatch => {
    dispatch({type: types.SET_SELECTED_PROVIDER_FILE.SUCCESS, payload: selected})
  }

  export const setApptrackLoading = () => dispatch => {
    dispatch({type: types.SET_APPTRACK_LOADING})
  }

  export const getAllTaskNames = () => dispatch => {
    dispatch({ type: types.GET_ALL_TASK_NAMES.START });

    instance
      .get(`/app/rest/all-task-names`)
      .then(response => {
        dispatch({
          type: types.GET_ALL_TASK_NAMES.SUCCESS,
          payload: response.data,
        });
      })
      .catch(error => {
        dispatch({ type: types.GET_ALL_TASK_NAMES.ERROR });

        console.log(error, 'error');
      });
  }

  export const addComment = (id, data) => dispatch => {
    const payload = {
      id: "",
      message: data,
      created: "",
      createdBy: "",
    };
  
    return instance
      .post(`/app/rest/process-instances/${id}/comments`, payload)
      .then(response => {
        // console.log("RESPONSE:", response.data);
        // dispatch({
        //   type: types.GET_ALL_TASK_NAMES.SUCCESS,
        //   payload: response.data,
        // });
      })
      .catch(error => {
        // dispatch({ type: types.GET_ALL_TASK_NAMES.ERROR });
        console.log(error, 'error');
      });
  };

  export const uploadReserveRedeeem = ({file, callback}) => dispatch => {
    dispatch({ type: types.UPLOAD_PROVIDER.START });
    instance
      .put(`/app/rest/providers/mass-reserve`, file)
      .then(response => {
        // console.log(response.data);
        dispatch({
          type: types.UPLOAD_PROVIDER.SUCCESS
        });
        callback(true);
      })
      .catch(error => {
        dispatch({ type: types.UPLOAD_PROVIDER.ERROR });
        callback(false);
        console.log(error, 'error');
      });
  };

  export const getProviderHistory = () => dispatch => {
    dispatch({ type: types.GET_PROVIDER_HISTORY.START });

    instance
      .get(`/app/rest/providers/uploads`)
      .then(response => {
        // console.log(response.data);
        dispatch({
          type: types.GET_PROVIDER_HISTORY.SUCCESS,
          payload: response.data,
        });
      })
      .catch(error => {
        dispatch({ type: types.GET_PROVIDER_HISTORY.ERROR });
        console.log(error, 'error');
      });
  };

  export const getProviderHistoryExcelDetail = (fileInfo,params) => dispatch => {
    message.loading("Αναμονή λήψης αρχείου");
    const status = params;
    // console.log({status});
    dispatch({ type: types.GET_PROVIDER_HISTORY_DETAILS.START });
    instance
      .post(`/app/rest/providers/details?fieldId=${fileInfo?.id}`, {status},{ responseType: "blob" })
      .then(response => {
        //create hidden anchor and click behind the scenes to trigger download
        const link = document.createElement("a");
        link.href = URL.createObjectURL(response.data);
        link.download = fileInfo?.filename;
        link.click();
        dispatch({
          type: types.GET_PROVIDER_HISTORY_DETAILS.SUCCESS,
        });
      })
      .catch(error => {
        console.log(error, 'error');
        dispatch({ type: types.GET_PROVIDER_HISTORY_DETAILS.ERROR });
        // message.error("Σφάλμα κατά τη λήψη του αρχείου");
      });
  };

  
